import { render, staticRenderFns } from "./ItemHistoryChange.vue?vue&type=template&id=162896f4&scoped=true"
import script from "./ItemHistoryChange.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162896f4",
  null
  
)

export default component.exports